import * as React from "react";

interface IProps {
  title: string;
  submit: number;
  delete: number;
  skip: number;
}
export default class ActivityRow extends React.Component<IProps> {
  public render() {
    const {
      title,
      submit: submitted,
      delete: deleted,
      skip: skipped
    } = this.props;

    return (
      <tr>
        <td>{title}</td>
        <td>{submitted}</td>
        <td>{deleted}</td>
        <td>{skipped}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductImageModeration/ActivityRow.tsx